module.exports = __webpack_public_path__ + "static/media/header.44274a45.jpg";